import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const login = (email, password) => {
    return axios.post(`${API_URL}/login`, { email, password }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

const selectProfile = (preAuthToken, center_id, role) => {
    return axios.post(`${API_URL}/auth/select-profile`, { center_id, role }, {
        headers: {
            Authorization: `Bearer ${preAuthToken}`
        }
    });
};

const logout = (token) => {
    return axios.post(`${API_URL}/logout`, {}, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
};

const getUserContext = (token) => {
    return axios.get(`${API_URL}/me`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
};

const refreshToken = (token) => {
    return axios.post(`${API_URL}/refresh-token`, {}, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
};

const authService = {
    login,
    selectProfile,
    logout,
    getUserContext,
    refreshToken,
};

export default authService;
